<script>
import { Menu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        links: []
      },
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [...this.getBaseFields()]
    },
    getBaseFields() {
      return [
        new fields.Link({
          label: 'Dolny link',
          modelPath: [this, 'form', 'bottom_link']
        }),
        new fields.Switch({
          label: 'Pokazuj przycisk "Sprawdź, jak zobaczyć więcej"',
          modelPath: [this, 'form', 'show_button']
        }),
        {
          component: 'h3',
          innerText: 'Linki'
        },
        new fields.Formset({
          modelPath: [this, 'form', 'links'],
          items: this.form.links.map((item, i) => {
            return {
              headerLabel: get(item, ['label']),
              fields: [
                new fields.Link({
                  label: 'Link',
                  modelPath: [this, 'form', 'links', i]
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return Menu
    }
  }
}
</script>
